import React from 'react';
import { X, Check } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function BeforeAfterSection() {
  const isFor = ['Personas con hernia hiatal que sufren dolor al acostarse.', 'Quienes dependen de antiácidos diarios y quieren dejar de tomarlos.', 'Profesionales que están perdiendo la voz o sufren de flema constante por el reflujo.', 'Víctimas de gastritis crónica que sienten "lumbre" en la boca del estómago después de comer.'];
  const notFor = ['Personas que buscan una solución mágica sin cambiar sus hábitos de cena.', 'Quienes prefieren seguir tomando químicos en lugar de usar remedios naturales.', 'Casos de emergencia médica que requieren cirugía inmediata.'];
  return <section id="para-quien" className="py-24" data-id="element-50">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-51">
        <SectionHeader tag="¿Es para ti?" title={<>
              Para quién es y para quién
              <br data-id="element-53" />
              <span className="text-danger-outlined" data-id="element-54">NO es este protocolo</span>
            </>} data-id="element-52" />

        <div className="scale-in grid grid-cols-1 md:grid-cols-2 gap-0 rounded-2xl overflow-hidden mt-12 border border-white/10" data-id="element-55">
          {/* Is For Column */}
          <div className="bg-success/5 p-8 md:p-10 border-b md:border-b-0 md:border-r border-white/5" data-id="element-56">
            <div className="flex items-center gap-3 mb-7" data-id="element-57">
              <div className="w-10 h-10 rounded-full bg-success/15 flex items-center justify-center" data-id="element-58">
                <Check className="w-5 h-5 text-success" data-id="element-59" />
              </div>
              <h3 className="text-lg font-bold text-[#68D391]" data-id="element-60">
                SÍ es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-61">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[15px] text-text-light" data-id="element-62">
                  <Check className="w-4 h-4 text-success mt-1 shrink-0" data-id="element-63" />
                  <span className="leading-relaxed" data-id="element-64">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For Column */}
          <div className="bg-danger/5 p-8 md:p-10" data-id="element-65">
            <div className="flex items-center gap-3 mb-7" data-id="element-66">
              <div className="w-10 h-10 rounded-full bg-danger/15 flex items-center justify-center" data-id="element-67">
                <X className="w-5 h-5 text-danger" data-id="element-68" />
              </div>
              <h3 className="text-lg font-bold text-danger-outlined" data-id="element-69">
                NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-70">
              {notFor.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[15px] text-text-muted" data-id="element-71">
                  <X className="w-4 h-4 text-danger mt-1 shrink-0" data-id="element-72" />
                  <span className="leading-relaxed" data-id="element-73">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}